import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M4.12132 12.1213L2 10M2 10L4.12132 7.87868M2 10H7.3033M12.6066 3.63604L10.4853 1.51472M10.4853 1.51472L8.36396 3.63604M10.4853 1.51472V6.81802M8.36396 16.364L10.4853 18.4853M10.4853 18.4853L12.6066 16.364M10.4853 18.4853V13.182M18.9706 10H13.6673M18.9706 10L16.8492 7.87868M18.9706 10L16.8492 12.1213" />
  </svg>
);
